/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
    Button,
    Stack,
    Paper,
    Typography,
    Divider,
    Grid,
    Box,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';
import get from "lodash/get";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";

import Layout from "../../../components/layout/Layout";
import Switch from "../../../components/form/Switch";
import InputText from "../../../components/form/InputText";
import Autocomplete from "../../../components/form/AutoComplete";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";
import validator from "./validator"

import { postClient } from "../../../store/masters/thunk/client/post"
import { getClientOdoo } from "../../../store/masters/thunk/client/getAllOdoo"

const NewEdit = () => {
    const formikRef = useRef();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [__] = useTranslation("client");
    const [showNoti, setShowNoti] = React.useState({ open: false, msg: "", variant: "error", action: "post" })
    const [alert, setAlert] = React.useState({ open: false, title: "", subtitle: "", type: "" });

    const post = useSelector(state => state.masters.client.post);
    const clientsOdoo = useSelector(state => state.masters.client.clientsOdoo);

    const userData = JSON.parse(localStorage.getItem('userData'));

    const municipalities = map(userData?.municipalities, ({ municipalityId, municipalityName }) => ({
        value: municipalityId,
        label: municipalityName,
    }))

    const departments = map(userData?.departments, ({ departmentId, description }) => ({
        value: departmentId,
        label: description,
    }))

    const optionsClientOdoo = map(get(clientsOdoo, "data.result", []), ({ id, name }) => ({
        value: id,
        label: `${id} - ${name}`,
    }))

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }

    const setError = (err) => {
        if (!isEmpty(err) && !!get(err, "Message", "")) {
            setAlert({
                open: true,
                title: get(err, "Message", ""),
                subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
                type: "error",
                func: closeAlert
            })
        } else {
            setAlert({ open: true, type: "default", func: closeAlert })
        }
    }

    useEffect(() => {
        dispatch(getClientOdoo());
    }, [dispatch]);

    const submittedIdRef = useRef("");

    useEffect(() => {
        if (get(post, "isSuccess", false)) {
            setShowNoti({ open: true, msg: "", variant: "success", action: "post" });
            navigate(`/masters/clients/${submittedIdRef.current}`);
        }
        if (get(post, "isReject", false)) { setError(get(post, "error", {})) }
    }, [post])

    const onSubmit = (values) => {
        submittedIdRef.current = values.customerId;
        dispatch(postClient({
            customerId: values.customerId,
            name: values.name,
            address: values.address,
            city: values.city,
            municipality: values.municipality || 0,
            department: values.department || 0,
            isActive: values.isActive ? 1 : 0,
            phone: values.phone,
            email: values.email,
            clientOdooId: values.clientOdooId || 0,
        }))
    }

    const initialValues = {
        isActive: true,
        customerId: "",
        name: "",
        address: "",
        city: "",
        municipality: "",
        department: "",
        phone: "",
        email: "",
        clientOdooId: "",
    }

    return (
        <Layout
            propsToolbar={{
                title: __(`head.new.name`),
                srute: __(`head.new.code`)
            }}
        >
            <Formik innerRef={formikRef} initialValues={initialValues} validationSchema={validator(__)} onSubmit={onSubmit}>
                {formik => (
                    <form id="form-client" onSubmit={get(formik, "handleSubmit")}>
                        <Paper className='p-4'>
                            <Stack direction="row" spacing={2} justifyContent="flex-end">
                                <LoadingButton variant="contained" color="secondary" type="submit" loading={get(post, "isLoading")}>{__(`action.save`)}</LoadingButton>
                                <Button variant='outlined' color="secondary" onClick={() => navigate("/masters/clients")} disabled={get(post, "isLoading")}>{__(`action.cancel`)}</Button>
                            </Stack>
                        </Paper>
                        <Paper className='mt-4'>
                            <Stack className='p-4' direction="row" spacing={2} justifyContent="space-between">
                                <Typography component="h4" variant="h4">{__(`labels.1`)}</Typography>
                                <Switch formik={formik} name="isActive" __={__} />
                            </Stack>
                            <Divider />
                            <Box className='p-4'>
                                <Grid container spacing={{ xs: 2, md: 3 }}>
                                    <Grid item xs={12} sm={6}>
                                        <InputText
                                            formik={formik}
                                            name="customerId"
                                            label={__(`form.customerId.label`)}
                                            placeholder={__(`form.customerId.label`)}
                                            disabled={get(post, "isLoading", false)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <InputText
                                            formik={formik}
                                            name="name"
                                            label={__(`form.name.label`)}
                                            placeholder={__(`form.name.label`)}
                                            disabled={get(post, "isLoading", false)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <InputText
                                            formik={formik}
                                            name="phone"
                                            label={__(`form.phone.label`)}
                                            placeholder={__(`form.phone.label`)}
                                            disabled={get(post, "isLoading", false)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <InputText
                                            formik={formik}
                                            name="email"
                                            label={__(`form.email.label`)}
                                            placeholder={__(`form.email.label`)}
                                            disabled={get(post, "isLoading", false)}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography className='pt-4' component="p" variant="bmr" color="text.lite">{__(`labels.3`)}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <InputText
                                            formik={formik}
                                            name="address"
                                            label={__(`form.address.label`)}
                                            placeholder={__(`form.address.label`)}
                                            disabled={get(post, "isLoading", false)}
                                            multiline
                                            rows={4}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <InputText
                                            formik={formik}
                                            name="city"
                                            label={__(`form.city.label`)}
                                            placeholder={__(`form.city.label`)}
                                            disabled={get(post, "isLoading", false)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Autocomplete
                                            formik={formik}
                                            name="department"
                                            label={__(`form.department.label`)}
                                            placeholder={__(`form.department.label`)}
                                            disabled={get(post, "isLoading", false)}
                                            options={departments}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Autocomplete
                                            formik={formik}
                                            name="municipality"
                                            label={__(`form.municipality.label`)}
                                            placeholder={__(`form.municipality.label`)}
                                            disabled={get(post, "isLoading", false)}
                                            options={municipalities}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Autocomplete
                                            formik={formik}
                                            name="clientOdooId"
                                            label={__(`form.clientOdooId.label`)}
                                            placeholder={__(`form.clientOdooId.label`)}
                                            disabled={get(post, "isLoading", false)}
                                            loading={get(clientsOdoo, "isLoading")}
                                            options={optionsClientOdoo}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </Paper>
                    </form>
                )}
            </Formik>
            <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
            <Alert
                __={__}
                title={get(alert, "title")}
                subtitle={get(alert, "subtitle")}
                btn1={{ func: get(alert, "func") }}
                btn2={{}}
                type={get(alert, "type")}
                openAlert={get(alert, "open")}
                closeAlert={closeAlert}
            />
        </Layout>
    )
}

export default NewEdit
